/**
 * Rota `/alarmes` — Fase 2 PR-C do TD26 roadmap.
 *
 * Inbox dos ONUs em status bad, ordenados por last_change_at desc.
 * Versão expandida do AlertList do Overview (que era só top 10).
 *
 * Pra primeira versão: sem filtros sofisticados. Operador navega cronologi-
 * camente do mais recente pro mais antigo. Filtros por status/idade entram
 * em PR sucessora se valer.
 *
 * Source: useSnapshot({status:'bad'}) compartilhado com Cockpit progressive
 * + Overview AlertList. Zero re-fetch.
 */

import { AlarmList } from '@/features/alarms/AlarmList';
import { AlarmsHeader } from '@/features/alarms/AlarmsHeader';
import { useSnapshot } from '@/features/onus/useSnapshot';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/alarmes')({
  component: AlarmesPage,
});

function AlarmesPage() {
  const { items, isPending, isError } = useSnapshot({ status: 'bad' });

  if (isPending) {
    return (
      <div className="flex h-full w-full items-center justify-center p-8 text-sm text-fg-subtle">
        Carregando alarmes…
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-2 p-8 text-sm">
        <p className="text-status-critical">Falha ao carregar alarmes.</p>
        <p className="text-fg-subtle">Reload da página tenta novamente.</p>
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <AlarmsHeader items={items} />
      <div className="flex-1 overflow-y-auto px-6 pb-6">
        <AlarmList items={items} />
      </div>
    </div>
  );
}
